import React, { useCallback } from 'react';

import { EikaModal } from '../../../../components/EikaModal';
import TransactionResultInfo from '../../../../components/transaction/TransactionResultInfo';
import useAccountChange from '../../../../fetchHooks/useAccountChange';
import useShowPaymentResult from '../../../../hooks/useShowPaymentResult';
import { sign } from '../../../../services/outboxService';
import SigningContextFlow from '../../../../signingContext/SigningContextFlow';
import { useSigningContext } from '../../../../signingContext/signingContext';
import { Actions } from '../../../../signingContext/signingTypes';

type OutboxApprovalModalProps = {
    show: boolean;
    hideModal(): void;
    onRetryManually(): void;
};

const ApprovalModal: React.FC<OutboxApprovalModalProps> = ({ show, hideModal, onRetryManually }) => {
    const { handleCancelSigningFlow, dispatch, signingStatus, signingError } = useSigningContext(sign);
    const cancelSigningFlow = useCallback(() => {
        handleCancelSigningFlow();
        hideModal();
    }, [handleCancelSigningFlow, hideModal]);

    const refreshCaches = useAccountChange();
    const onClose = useCallback(() => {
        if (signingStatus === 'COMPLETED') {
            hideModal();
            refreshCaches();
        } else {
            cancelSigningFlow();
        }
        dispatch({ type: Actions.RESET });
    }, [refreshCaches, cancelSigningFlow, dispatch, hideModal, signingStatus]);

    const showResult = useShowPaymentResult();

    return (
        <EikaModal
            id="payment-approve-all-modal-signing-flow"
            onClose={onClose}
            setOpen={() => null}
            open={show}
            timeOut={signingStatus === 'COMPLETED' && !signingError ? 2000 : undefined}
        >
            {showResult ? (
                <TransactionResultInfo
                    type="PAYMENT"
                    status={signingStatus}
                    error={signingError}
                    retry={signingError ? handleCancelSigningFlow : onClose}
                    onClose={onClose}
                    onRetryManually={onRetryManually}
                />
            ) : (
                <SigningContextFlow onClosePayment={cancelSigningFlow} />
            )}
        </EikaModal>
    );
};

export default ApprovalModal;
